<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.03809 10.6592H20.9619C21.8743 10.6594 22.6472 11.371 22.7402 12.3096L22.75 12.5V19.4092C22.75 20.4402 21.9351 21.2498 20.9619 21.25H4.03809C3.06493 21.2498 2.25005 20.4402 2.25 19.4092V12.5C2.25 11.4689 3.0649 10.6594 4.03809 10.6592ZM4.03809 3.75H10.1064C10.3208 3.75 10.5301 3.82606 10.6982 3.9668L10.7676 4.03125L13.1611 6.47363C13.6179 6.93975 14.2409 7.2041 14.8936 7.2041H20.9619C21.9351 7.20431 22.75 8.01479 22.75 9.0459V9.69629C22.2368 9.35742 21.6239 9.15925 20.9619 9.15918H4.03809C3.37605 9.15925 2.76319 9.35742 2.25 9.69629V5.59082C2.25005 4.55976 3.06493 3.75021 4.03809 3.75Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<mask id="path-2-inside-1_1486_3009" fill="white">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M17.1665 14.7918C17.1665 14.0185 17.7933 13.3916 18.5666 13.3916C19.3399 13.3916 19.9668 14.0185 19.9668 14.7918C19.9668 15.5651 19.3399 16.192 18.5666 16.192C17.7933 16.192 17.1665 15.5651 17.1665 14.7918Z"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M16 19.1807C16.0241 17.7837 17.164 16.6587 18.5666 16.6587C19.9694 16.6587 21.1092 17.7837 21.1333 19.1808C21.1349 19.2734 21.0815 19.3582 20.9973 19.3969C20.257 19.7365 19.4337 19.9258 18.5667 19.9258C17.6997 19.9258 16.8763 19.7365 16.136 19.3968C16.0518 19.3581 15.9984 19.2733 16 19.1807Z"
				/>
			</mask>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M17.1665 14.7918C17.1665 14.0185 17.7933 13.3916 18.5666 13.3916C19.3399 13.3916 19.9668 14.0185 19.9668 14.7918C19.9668 15.5651 19.3399 16.192 18.5666 16.192C17.7933 16.192 17.1665 15.5651 17.1665 14.7918Z"
				:fill="color"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M16 19.1807C16.0241 17.7837 17.164 16.6587 18.5666 16.6587C19.9694 16.6587 21.1092 17.7837 21.1333 19.1808C21.1349 19.2734 21.0815 19.3582 20.9973 19.3969C20.257 19.7365 19.4337 19.9258 18.5667 19.9258C17.6997 19.9258 16.8763 19.7365 16.136 19.3968C16.0518 19.3581 15.9984 19.2733 16 19.1807Z"
				:fill="color"
			/>
			<path
				d="M16 19.1807L17.4998 19.2065L17.4998 19.2065L16 19.1807ZM21.1333 19.1808L22.633 19.155L22.633 19.155L21.1333 19.1808ZM20.9973 19.3969L21.6228 20.7602L21.6228 20.7602L20.9973 19.3969ZM16.136 19.3968L15.5104 20.7601L15.5104 20.7601L16.136 19.3968ZM18.5666 13.3916V11.8916C16.9649 11.8916 15.6665 13.1901 15.6665 14.7918H17.1665H18.6665C18.6665 14.8469 18.6218 14.8916 18.5666 14.8916V13.3916ZM19.9668 14.7918H21.4668C21.4668 13.1901 20.1684 11.8916 18.5666 11.8916V13.3916V14.8916C18.5115 14.8916 18.4668 14.8469 18.4668 14.7918H19.9668ZM18.5666 16.192V17.692C20.1684 17.692 21.4668 16.3935 21.4668 14.7918H19.9668H18.4668C18.4668 14.7367 18.5115 14.692 18.5666 14.692V16.192ZM17.1665 14.7918H15.6665C15.6665 16.3935 16.9649 17.692 18.5666 17.692V16.192V14.692C18.6218 14.692 18.6665 14.7367 18.6665 14.7918H17.1665ZM18.5666 16.6587V15.1587C16.3442 15.1587 14.5384 16.9411 14.5003 19.1548L16 19.1807L17.4998 19.2065C17.5098 18.6263 17.9838 18.1587 18.5666 18.1587V16.6587ZM21.1333 19.1808L22.633 19.155C22.595 16.9412 20.7892 15.1587 18.5666 15.1587V16.6587V18.1587C19.1495 18.1587 19.6235 18.6263 19.6335 19.2066L21.1333 19.1808ZM20.9973 19.3969L21.6228 20.7602C22.2484 20.4732 22.6449 19.8432 22.633 19.155L21.1333 19.1808L19.6335 19.2065C19.6248 18.7037 19.9146 18.2433 20.3717 18.0336L20.9973 19.3969ZM18.5667 19.9258V21.4258C19.6539 21.4258 20.6903 21.1881 21.6228 20.7602L20.9973 19.3969L20.3717 18.0336C19.8238 18.285 19.2134 18.4258 18.5667 18.4258V19.9258ZM16.136 19.3968L15.5104 20.7601C16.443 21.1881 17.4795 21.4258 18.5667 21.4258V19.9258V18.4258C17.92 18.4258 17.3096 18.285 16.7617 18.0335L16.136 19.3968ZM16 19.1807L14.5003 19.1548C14.4884 19.843 14.8848 20.473 15.5104 20.7601L16.136 19.3968L16.7617 18.0335C17.2188 18.2433 17.5085 18.7036 17.4998 19.2065L16 19.1807Z"
				:fill="color"
				mask="url(#path-2-inside-1_1486_3009)"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgMemberDirectory',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
